const pathArray = [
  { path: "/waste-journal", title: "Žurnalas" },
  { path: "/waste-management", title: "Tvarkymas" },
  { path: "/waste-disposal", title: "Sutvarkytos atliekos" },
  { path: "/waste-accumulation", title: "Susidarymas" },
  { path: "/disposal", title: "Perdavimas" },
  { path: "/disposal-journal", title: "Perdavimo užsakymų žurnalas" },
];
export default pathArray;
